import _ from 'lodash';
import { isStaticElement } from 'crazyEditor/core/elements/utils/elementStaticUtils';

export function normalizeElementsIfNeeded(elements) {
  const normalizedElements = {
    staticElements: {},
    elements: {}
  };
  if (_.isArray(elements)) { // legacy - elements used to be array
    _.forEach(elements, (element) => {
      if (isStaticElement(element.id)) {
        normalizedElements.staticElements[element.id] = element;
      } else {
        normalizedElements.elements[element.id] = element;
      }
    });
    return normalizedElements;
  } else if (_.isObject(elements)) {
    normalizedElements.staticElements = elements.staticElements || {};
    normalizedElements.elements = elements.elements || {};
  } else {
    throw new Error('Corrupted data');
  }

  return normalizedElements;
}
